import React, {useState, useCallback, useRef} from 'react';

function DragAndDropUpload({onFileChange}) {
    const [file, setFile] = useState(null);
    const [dragging, setDragging] = useState(false);
    const [error, setError] = useState(null);
    const inputRef = useRef(null);

    const handleFileChange = (selectedFile) => {
        setError(null);
        if (selectedFile) {
            if (selectedFile.type === "text/csv" || selectedFile.name.endsWith('.csv')) {
                setFile(selectedFile);
                onFileChange(selectedFile);
                // console.log("CSV file selected:", selectedFile);
            } else {
                setError("Please select a CSV file");
                console.error("Please select a CSV file");
            }
        } else {
            setError("No file selected");
            console.error("No file selected");
        }
    };

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setError(null);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFileChange(e.dataTransfer.files[0]);
        } else {
            setError("No file dropped");
        }
        setDragging(false);
    }, []);

    const handleDrag = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleDragIn = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(true);
    }, []);

    const handleDragOut = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
    }, []);

    return (
        <div className="mb-0">
            <label
                onDrop={handleDrop}
                onDragOver={handleDrag}
                onDragEnter={handleDragIn}
                onDragLeave={handleDragOut}
                className={`flex flex-col items-center justify-center w-full h-32 transition bg-white appearance-none cursor-pointer focus:outline-none`}
            >
                <svg className="w-10 h-10 mb-3 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                </svg>
                <p className="mb-2 text-base text-gray-700">
                    <span className="font-semibold">Click to upload</span> or drag and drop
                </p>
                <p className="text-sm text-gray-500">
                    CSV files only
                </p>
                <input
                    ref={inputRef}
                    type="file"
                    accept=".csv"
                    name="file_upload"
                    className="hidden"
                    onChange={(e) => {
                        if (e.target && e.target.files && e.target.files[0]) {
                            handleFileChange(e.target.files[0]);
                        } else {
                            setError("No file selected");
                        }
                    }}
                />
            </label>
            {file && <div className="mt-3 text-sm font-medium text-gray-600">Selected: {file.name}</div>}
            {error && <div className="mt-3 text-sm font-medium text-red-500">{error}</div>}
        </div>
    );
}

export default DragAndDropUpload;